import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "qLogo.svg",
  "use": "qLogo.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"qLogo.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.7689 11.8157C16.2044 11.8157 19.8 15.4113 19.8 19.8468V19.9157H11.6311C7.19562 19.9157 3.60001 16.3201 3.60001 11.8847V11.8157H11.7689ZM11.6683 3.60001C16.1593 3.60001 19.8 7.23638 19.8 11.7221C19.8005 12.4175 19.7118 13.1101 19.536 13.7829C17.649 11.4928 14.9412 10.0475 11.9284 10.0189L11.837 10.0184L3.71572 10.0184C4.52337 6.27252 7.83633 3.59868 11.6683 3.60001H11.6683Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol